import { useTranslation } from '@/i18n';
import {
  Bottom,
  ListView,
  ListViewBody,
  ListViewLabel,
  TextLink,
  Top,
} from '@moneyforward/ap-frontend-components';
import { ApprovingInvoiceReportBusinessDocumentResponse } from 'ap-openapi';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from '../styles.module.scss';

const cx = classnames.bind(styles);

interface BusinessDocumentSectionProps {
  businessDoc: ApprovingInvoiceReportBusinessDocumentResponse;
  labels: {
    documentTitleLabel: string;
    receiptTypeLabel: string;
    documentTypeLabel: string;
    picsLabel: string;
    counterpartyNameLabel: string;
    transactionDateLabel: string;
    amountLabel: string;
    memoLabel: string;
  };
  leftRightRatio: {
    left: { value: string };
    right: { value: string };
  };
  navigate: string;
}

export const BusinessDocumentSection: FC<BusinessDocumentSectionProps> = memo(
  ({ businessDoc, labels, leftRightRatio, navigate }) => {
    const { t } = useTranslation();

    return (
      <>
        <div className={cx('section-title')}>{t('business_document_info')}</div>
        <ListView leftRightRatio={leftRightRatio}>
          {businessDoc.searchable_number && (
            <Top>
              <ListViewLabel>{t('business_document_id')}</ListViewLabel>
              <ListViewBody className={cx('list-view-body')}>
                <TextLink
                  target='_blank'
                  href={navigate}
                  className={cx('text-link')}
                >
                  {`Doc-${businessDoc.searchable_number}`}
                </TextLink>
              </ListViewBody>
            </Top>
          )}
          <Top>
            <ListViewLabel>{t('business_document_file_name')}</ListViewLabel>
            <ListViewBody className={cx('list-view-body')}>
              <div>{labels.documentTitleLabel}</div>
            </ListViewBody>
          </Top>
          <Top>
            <ListViewLabel>{t('business_document_receipt_type')}</ListViewLabel>
            <ListViewBody>{labels.receiptTypeLabel}</ListViewBody>
          </Top>
          <Top>
            <ListViewLabel>
              {t('business_document_document_type')}
            </ListViewLabel>
            <ListViewBody>{labels.documentTypeLabel}</ListViewBody>
          </Top>
          <Top>
            <ListViewLabel>{t('business_document_pics')}</ListViewLabel>
            <ListViewBody className={cx('list-view-body')}>
              {labels.picsLabel}
            </ListViewBody>
          </Top>
          <Top>
            <ListViewLabel>
              {t('business_document_counterparty_name')}
            </ListViewLabel>
            <ListViewBody className={cx('list-view-body')}>
              {labels.counterpartyNameLabel}
            </ListViewBody>
          </Top>
          <Top>
            <ListViewLabel>
              {t('business_document_transaction_date')}
            </ListViewLabel>
            <ListViewBody className={cx('list-view-body')}>
              {labels.transactionDateLabel}
            </ListViewBody>
          </Top>
          <Top>
            <ListViewLabel>{t('business_document_amount')}</ListViewLabel>
            <ListViewBody className={cx('list-view-body')}>
              {labels.amountLabel}
            </ListViewBody>
          </Top>
          <Bottom>
            <ListViewLabel>{t('business_document_memo')}</ListViewLabel>
            <ListViewBody className={cx('list-view-body')}>
              {labels.memoLabel}
            </ListViewBody>
          </Bottom>
        </ListView>
      </>
    );
  }
);

BusinessDocumentSection.displayName = 'BusinessDocumentSection';
